import { createFileRoute, Link } from "@tanstack/react-router";

export const Route = createFileRoute("/scraper-policy")({
  component: ScraperPolicyPage,
});

function ScraperPolicyPage() {
  return (
    <main className="mx-auto w-full max-w-2xl px-4 sm:px-5 py-8 prose prose-invert flex-1">
      <p className="text-xs text-[color:var(--color-fg-muted)] mb-2">
        <Link to="/" className="hover:underline">← back</Link>
      </p>
      <h1>Scraper policy</h1>
      <p>
        Bargain Radar collects some of its deal listings by automated scrape of public
        Australian retailer pages. This page tells retailers and brands what we do,
        how we do it, and how to make us stop.
      </p>

      <h2>What we collect</h2>
      <ul>
        <li>Deal title</li>
        <li>Retailer SKU (when the retailer exposes one)</li>
        <li>Canonical product URL</li>
        <li>Currently observed price</li>
        <li>The retailer's own "was" / strikethrough price <strong>when the live page carries one</strong>. We never compute our own "% off" from price history.</li>
        <li>Product image URL — we link directly to the retailer's CDN; we do not rehost</li>
        <li>Category derived from the URL path</li>
      </ul>
      <p>
        We do not collect descriptions, reviews, stock counts, or any personal data.
        We never log in to retailer sites, never accept cookies, and never scrape behind
        an account wall.
      </p>

      <h2>How we identify ourselves</h2>
      <p>
        Every request our scraper makes carries:
      </p>
      <pre><code>User-Agent: BargainRadar/1.0 (+https://bargainradar.com.au/scraper-policy; abuse@bargainradar.com.au)</code></pre>
      <p>
        We honour <code>robots.txt</code>: only paths your robots.txt permits are
        fetched. Crawl rate is at least 2 seconds between requests to the same host,
        and runs are scheduled at most every 30 minutes.
      </p>

      <h2>Freshness</h2>
      <p>
        Every scraped price is stamped <em>"verified X ago"</em> in the UI. Discount
        badges are hidden when our verification is more than 6 hours old, and the row
        is re-verified when a user clicks through to the retailer. If a price or
        availability has changed by the time the user clicks, we mark the deal expired
        and drop it from the feed.
      </p>

      <h2>Takedown</h2>
      <p>
        If you are a retailer, brand, or rights-holder and want us to remove a listing,
        email <a href="mailto:abuse@bargainradar.com.au">abuse@bargainradar.com.au</a>
        with the deal URL or SKU. We will action within <strong>24 hours</strong> from
        receipt. We keep an internal audit row of every request indefinitely
        (your email is retained for 7 years then automatically deleted while the rest
        of the audit row stays).
      </p>

      <h2>Contact</h2>
      <ul>
        <li>Takedown / abuse: <a href="mailto:abuse@bargainradar.com.au">abuse@bargainradar.com.au</a></li>
        <li>General questions: hello@bargainradar.com.au</li>
      </ul>
      <p className="text-xs text-[color:var(--color-fg-muted)]">
        Bargain Radar is an independent aggregator. Retailer names and logos are
        trademarks of their respective owners; their use on this site is nominative
        and does not imply affiliation or endorsement.
      </p>
    </main>
  );
}
